// Delivery estimate block (product page): recounts the merchant's estimate at
// view time (cached pages keep Liquid's first count) and writes the dates in the
// shopper's language. Business days skip weekends (setting) and closed dates;
// the day starts in the store's time zone (data-store-offset, from Liquid).
// Hidden for variants it doesn't apply to (data-hidden-variants) on variant change.
(function () {
  'use strict';

  if (window.AxiomDeliveryEstimate) return;

  var DAY = 86400000;

  function storeOffsetMinutes(value) {
    var match = /^([+-])(\d{2}):?(\d{2})$/.exec(String(value || '').trim());
    if (!match) return -new Date().getTimezoneOffset();
    var minutes = Number(match[2]) * 60 + Number(match[3]);
    return match[1] === '-' ? -minutes : minutes;
  }

  function isoDate(date) {
    return date.toISOString().slice(0, 10);
  }

  // Dates are counted as UTC midnights that stand for the store's calendar days.
  function estimate(element) {
    var data = element.dataset;
    var processing = Number(data.processingDays) || 0;
    var shippingMin = Number(data.shippingMin) || 0;
    var shippingMax = Number(data.shippingMax) || 0;
    if (shippingMax < shippingMin) {
      var swap = shippingMin;
      shippingMin = shippingMax;
      shippingMax = swap;
    }
    var cutoff = Number(data.cutoffHour);
    if (!Number.isFinite(cutoff)) cutoff = 24;
    var skipWeekends = data.skipWeekends === 'true';
    var closed = String(data.closedDates || '').split(',').map(function (value) {
      return value.trim();
    }).filter(Boolean);

    var storeNow = new Date(Date.now() + storeOffsetMinutes(data.storeOffset) * 60000);
    var day = new Date(Date.UTC(storeNow.getUTCFullYear(), storeNow.getUTCMonth(), storeNow.getUTCDate()));
    var afterCutoff = cutoff < 24 && storeNow.getUTCHours() >= cutoff;
    if (afterCutoff) day = new Date(day.getTime() + DAY);

    function isBusinessDay(date) {
      var weekday = date.getUTCDay();
      if (skipWeekends && (weekday === 0 || weekday === 6)) return false;
      return closed.indexOf(isoDate(date)) === -1;
    }

    var counted = -1;
    var shipping = false;
    var first = day;
    var last = day;
    for (var i = 0; i < 120; i++) {
      if (isBusinessDay(day)) {
        counted += 1;
        if (!shipping && counted === processing) {
          shipping = true;
          counted = 0;
        }
        if (shipping) {
          if (counted === shippingMin) first = day;
          if (counted === shippingMax) {
            last = day;
            break;
          }
        }
      }
      day = new Date(day.getTime() + DAY);
    }
    return { first: first, last: last, afterCutoff: afterCutoff };
  }

  function formatter(locale) {
    var options = { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' };
    try {
      return new Intl.DateTimeFormat(locale || undefined, options);
    } catch (error) {
      return new Intl.DateTimeFormat(undefined, options);
    }
  }

  function render(element) {
    var dates = estimate(element);
    var format = formatter(element.dataset.locale);
    var lastLabel = format.format(dates.last);
    var rangeLabel = lastLabel;
    if (isoDate(dates.first) !== isoDate(dates.last)) {
      rangeLabel = typeof format.formatRange === 'function'
        ? format.formatRange(dates.first, dates.last)
        : format.format(dates.first) + ' – ' + lastLabel;
    }
    element.querySelectorAll('[data-delivery-estimate-date]').forEach(function (node) {
      node.textContent = lastLabel;
    });
    element.querySelectorAll('[data-delivery-estimate-range]').forEach(function (node) {
      node.textContent = rangeLabel;
    });
    // Two wordings (before / after today's cutoff) when the merchant set the second one.
    element.querySelectorAll('[data-delivery-estimate-message]').forEach(function (node) {
      node.hidden = (node.dataset.deliveryEstimateMessage === 'after') !== dates.afterCutoff;
    });
  }

  function numericId(value) {
    var match = /(\d+)$/.exec(String(value || ''));
    return match ? match[1] : '';
  }

  function setVariant(element, variantId) {
    var hidden = String(element.dataset.hiddenVariants || '').split(',');
    var id = numericId(variantId);
    element.hidden = !id || hidden.indexOf(id) !== -1;
  }

  function initialize(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-delivery-estimate]').forEach(render);
  }

  // Variant changes on the product page (Shopify standard event, product.js).
  document.addEventListener('shopify:product:select', function (event) {
    var source = event.target;
    if (!source || !source.querySelectorAll) return;
    var elements = Array.prototype.slice.call(source.querySelectorAll('[data-delivery-estimate]'));
    if (!elements.length || !event.promise) return;
    event.promise.then(function (result) {
      var variant = result && result.variant;
      elements.forEach(function (element) {
        setVariant(element, variant ? variant.id : '');
      });
    }).catch(function () {});
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  window.AxiomDeliveryEstimate = { initialize: initialize, estimate: estimate };
})();
